import { Flex, Box } from 'reflexbox';

import Paragraph, { ParagraphSmall } from '../common/Paragraph';
import Button, { ButtonSize } from '../editors/Button';

import { PopoverContainer, PopoverArrow, PopoverContents } from './Popover';

export default function PopoverConfirm({
	onConfirm,
	title,
	description,
	confirmButtonTitle,
	cancelButtonTitle,
}: {
	onConfirm: (confirmed: boolean) => void;
	title: string;
	description: string;
	confirmButtonTitle: string;
	cancelButtonTitle: string;
}) {
	return (
		<PopoverContainer>
			<PopoverArrow />
			<PopoverContents p={3}>
				<Box mb={3}>
					<Box mb={2}>
						<Paragraph color="antracite">{title}</Paragraph>
					</Box>
					<ParagraphSmall color="lightBlueDark">{description}</ParagraphSmall>
				</Box>

				<Flex>
					<Box mr={2}>
						<Button
							size={ButtonSize.Medium}
							onClick={(event) => {
								event.stopPropagation();
								onConfirm(true);
							}}
						>
							{confirmButtonTitle}
						</Button>
					</Box>
					<Button
						size={ButtonSize.Medium}
						onClick={(event) => {
							event.stopPropagation();
							onConfirm(false);
						}}
					>
						{cancelButtonTitle}
					</Button>
				</Flex>
			</PopoverContents>
		</PopoverContainer>
	);
}
